// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.system-receipt-layout .simple-header {
  width: 100%;
  text-align: left;
}
.system-receipt-layout .simple-header .receipt-header-image {
  max-width: 100%;
  height: auto;
}
.system-receipt-layout .receipt-title {
  text-align: center;
}
.system-receipt-layout .receipt-title h1 {
  font-size: 20px;
  font-weight: bold;
  color: #004A9A;
  margin: 0;
  padding: 10px;
  border: 2px solid #004A9A;
  display: inline-block;
  letter-spacing: 2px;
}
.system-receipt-layout .single-block-info {
  line-height: 1.6;
  font-size: 14px;
  border-bottom: 1px solid #000;
  padding-bottom: 10px;
  margin-bottom: 10px;
  margin-top: 20px;
}
.system-receipt-layout .single-block-info p {
  margin: 4px 0;
}
.system-receipt-layout .single-block-info p strong {
  font-weight: 600;
}
.system-receipt-layout .system-receipt-table {
  width: 100%;
  border-collapse: collapse;
  margin: 15px 0 20px 0;
  border: 1px solid #000;
}
.system-receipt-layout .system-receipt-table thead th {
  padding: 12px;
  text-align: left;
  font-weight: bold;
  border: 1px solid #000;
}
.system-receipt-layout .system-receipt-table thead th:nth-child(2) {
  text-align: right;
  width: 25%;
}
.system-receipt-layout .system-receipt-table tbody tr {
  border: 1px solid #000;
}
.system-receipt-layout .system-receipt-table tbody tr:not(.grand-total-row) td {
  padding: 12px;
  vertical-align: top;
  border: 1px solid #000;
}
.system-receipt-layout .system-receipt-table tbody tr:not(.grand-total-row) td:nth-child(2) {
  text-align: right;
}
.system-receipt-layout .system-receipt-table tbody tr.grand-total-row {
  font-weight: bold;
}
.system-receipt-layout .system-receipt-table tbody tr.grand-total-row td {
  padding: 12px;
  border: 1px solid #000;
  font-size: 15px;
}
.system-receipt-layout .simple-footer .bank-details-section {
  margin: 20px 0 20px 0;
  line-height: 1.8;
}
.system-receipt-layout .simple-footer .bank-details-section p {
  margin: 8px 0;
  font-size: 14px;
}
.system-receipt-layout .simple-footer .bank-details-section p strong {
  font-weight: 600;
}
.system-receipt-layout .simple-footer .footer-message {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #ddd;
}
.system-receipt-layout .simple-footer .footer-message .system-generated-note {
  font-size: 13px;
  color: #666;
  text-align: center;
  font-style: italic;
}
.system-receipt-layout .req-pad {
  padding: 0 20px;
}`, "",{"version":3,"sources":["webpack://./src/pages/SystemReceiptPdfTemplate/SystemReceiptPdfTemplate.scss"],"names":[],"mappings":"AAOE;EACE,WAAA;EACA,gBAAA;AANJ;AAQI;EACE,eAAA;EACA,YAAA;AANN;AAWE;EACE,kBAAA;AATJ;AAWI;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;AATN;AAcE;EACE,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;AAZJ;AAcI;EACE,aAAA;AAZN;AAaM;EACE,gBAAA;AAXR;AAiBE;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,sBAAA;AAfJ;AAkBM;EACE,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AAhBR;AAkBQ;EACE,iBAAA;EACA,UAAA;AAhBV;AAsBM;EACE,sBAAA;AApBR;AAuBU;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;AArBZ;AAuBY;EACE,iBAAA;AArBd;AA0BQ;EACE,iBAAA;AAxBV;AA0BU;EACE,aAAA;EACA,sBAAA;EACA,eAAA;AAxBZ;AAiCI;EACE,qBAAA;EACA,gBAAA;AA/BN;AAiCM;EACE,aAAA;EACA,eAAA;AA/BR;AAiCQ;EACE,gBAAA;AA/BV;AAoCI;EACE,gBAAA;EACA,iBAAA;EACA,0BAAA;AAlCN;AAoCM;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AAlCR;AAwCE;EACE,eAAA;AAtCJ","sourcesContent":["// Styles for SystemReceiptPdfTemplate\n\n\n\n.system-receipt-layout {\n  // 1. HEADER: Simple Image Style (with 100% width)\n  \n  .simple-header {\n    width: 100%;\n    text-align: left;\n\n    .receipt-header-image {\n      max-width: 100%;\n      height: auto;\n    }\n  }\n\n  // 2. TITLE: Updated with Blue Box\n  .receipt-title {\n    text-align: center;\n    \n    h1 {\n      font-size: 20px;\n      font-weight: bold;\n      color: #004A9A;\n      margin: 0;\n      padding: 10px;\n      border: 2px solid #004A9A;\n      display: inline-block;\n      letter-spacing: 2px;\n    }\n  }\n\n  // 3. INFO BOX: Reduced spacing\n  .single-block-info {\n    line-height: 1.6;\n    font-size: 14px;\n    border-bottom: 1px solid #000;\n    padding-bottom: 10px;\n    margin-bottom: 10px;\n    margin-top: 20px;\n\n    p {\n      margin: 4px 0;\n      strong {\n        font-weight: 600;\n      }\n    }\n  }\n\n  // 4. TABLE STYLES: Receipt specific\n  .system-receipt-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin: 15px 0 20px 0;\n    border: 1px solid #000;\n\n    thead {\n      th {\n        padding: 12px;\n        text-align: left;\n        font-weight: bold;\n        border: 1px solid #000;\n        \n        &:nth-child(2) {\n          text-align: right;\n          width: 25%;\n        }\n      }\n    }\n    \n    tbody {\n      tr {\n        border: 1px solid #000;\n        \n        &:not(.grand-total-row) {\n          td {\n            padding: 12px;\n            vertical-align: top;\n            border: 1px solid #000;\n            \n            &:nth-child(2) {\n              text-align: right;\n            }\n          }\n        }\n        \n        &.grand-total-row {\n          font-weight: bold;\n          \n          td {\n            padding: 12px;\n            border: 1px solid #000;\n            font-size: 15px;\n          }\n        }\n      }\n    }\n  }\n\n  // 5. FOOTER: Reduced spacing\n  .simple-footer {\n    .bank-details-section {\n      margin: 20px 0 20px 0;\n      line-height: 1.8;\n      \n      p {\n        margin: 8px 0;\n        font-size: 14px;\n        \n        strong {\n          font-weight: 600;\n        }\n      }\n    }\n\n    .footer-message {\n      margin-top: 30px;\n      padding-top: 20px;\n      border-top: 1px solid #ddd;\n\n      .system-generated-note {\n        font-size: 13px;\n        color: #666;\n        text-align: center;\n        font-style: italic;\n      }\n    }\n  }\n\n  // Additional padding class\n  .req-pad {\n    padding: 0 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
